import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private isToastActive = false;

  constructor(private snackBar: MatSnackBar) {}

  showError(message: string) {
    // If a toast is already showing, ignore new requests for the same error
    if (this.isToastActive) return;

    this.isToastActive = true;

    const snackRef = this.snackBar.open(message, 'Close', {
      duration: 5000,
      panelClass: ['error-snackbar'], // You can style this in styles.css
      verticalPosition: 'top'
    });

    // Reset the gatekeeper when the toast is dismissed
    snackRef.afterDismissed().subscribe(() => {
      this.isToastActive = false;
    });
  }
}
